<template>
<svg viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-ChuFangDianQi2`]" width="1em" height="1em" v-bind="$attrs"><path d="M17.1216 0.382812H9.65782C8.38326 0.382812 7.34644 1.41961 7.34644 2.69419V22.21C7.34644 23.4845 8.38323 24.5213 9.65782 24.5213H17.1216C18.3962 24.5213 19.433 23.4845 19.433 22.21V2.69419C19.433 1.41963 18.3962 0.382812 17.1216 0.382812ZM9.65782 1.92374H17.1216C17.5464 1.92374 17.8921 2.26948 17.8921 2.69419V11.7768H8.88737V2.69419C8.88737 2.26946 9.23308 1.92374 9.65782 1.92374ZM17.1216 22.9804H9.65782C9.23308 22.9804 8.88737 22.6347 8.88737 22.21V13.3177H17.8921V22.21C17.8921 22.6347 17.5464 22.9804 17.1216 22.9804Z" :fill="useCurrentColor ? 'currentColor' : '#000'"/><path d="M10.2084 11.0047C10.6339 11.0047 10.9789 10.6598 10.9789 10.2343V9.46381C10.9789 9.03833 10.6339 8.69336 10.2084 8.69336 9.78295 8.69336 9.43799 9.03833 9.43799 9.46381V10.2343C9.43796 10.6597 9.78295 11.0047 10.2084 11.0047zM10.2084 14.0879C9.78295 14.0879 9.43799 14.4329 9.43799 14.8583V15.6288C9.43799 16.0543 9.78295 16.3992 10.2084 16.3992 10.6339 16.3992 10.9789 16.0543 10.9789 15.6288V14.8583C10.9789 14.4329 10.6339 14.0879 10.2084 14.0879z" :fill="useCurrentColor ? 'currentColor' : '#000'"/></svg>
</template>
<script>

export default {
  name: 'IconChuFangDianQi2',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
